import React from "react";
import logo from "../../assets/logo.png";
import "./BlizuLoader.scss";

const BlizuLoader = ({
  message = "Cargando...",
  fullScreen = false,
  size = "default", // 'small' | 'default' | 'large'
  style = {},
  className = "",
}) => {
  return (
    <div
      className={`blizu-loader-wrapper ${fullScreen ? "fullscreen" : ""} size-${size} ${className}`}
      style={style}
    >
      <div className="loader-content">
        <div className="logo-glow-container">
          <div className="glow-halo" />
          <img src={logo} alt="Blizu" className="blizu-pulse-logo" />
        </div>

        <div className="loader-bar-track">
          <div className="loader-bar-fill" />
        </div>

        {message && <p className="loader-status-text">{message}</p>}
      </div>
    </div>
  );
};

export default BlizuLoader;
